import { Box } from '@mui/material';

export const OT = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
